import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=529c9e5c&scoped=true"
import script from "./tabbar.vue?vue&type=script&lang=js"
export * from "./tabbar.vue?vue&type=script&lang=js"
import style0 from "./tabbar.vue?vue&type=style&index=0&id=529c9e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c9e5c",
  null
  
)

export default component.exports